package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_11_19_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-11-19")
@Composable
public fun Log_2023_11_19(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Gem Shopping and Spies",
        ogTitle = "Gem Shopping and Spies",
        date = LocalDate(2_023, 11, 19),
        ogDescription = "While shopping for crafting gems, Bigglesworth detects a spy following them to a mercenary headquarters.",
        ogImage = "ai/2023-11-19.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-37", dateString = "Newgrowth 37")
        Log_2023_11_19_Day_1()
    }
}
